
<ul class="breadcrumb breadcrumb-page">
  <!--<div class="breadcrumb-label text-light-gray">{{'YouAreHere' | translate}}: </div>-->
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'Profile Settings' | translate}}</li>
</ul>
<div class="page-header">

  <div class="row">
    <!-- Page header, center on small screens -->
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><i class="fa fa-dashboard page-header-icon"></i>&nbsp;&nbsp;{{'Profile Settings' | translate}}</h1>


  </div>
</div>
<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'Profile Managements' | translate}}</span>

  </div>

  <div class="panel-body padding-sm-hr">

    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">



      <div [@fadeInOut] class="row">
        <div class="col-sm-12">
          <ul bootstrapTab #tab="bootstrap-tab" class="nav nav-tabs nav-tabs-light-green" (showBSTab)="onShowTab($event)">
            <li class="active">
              <a id="profileTab" [routerLink]="[]" fragment="profile" href="#profile" data-toggle="tab"><i class="fa fa-user-circle-o fa-fw" aria-hidden="true"></i> {{'pageHeader.Profile' | translate}}</a>
            </li>
           
            <li [hidden]="!canViewUsers">
              <a id="usersTab" [routerLink]="[]" fragment="users" href="#users" data-toggle="tab"><i class="fa fa-users fa-fw" aria-hidden="true"></i> {{'pageHeader.Users' | translate}}</a>
            </li>
            <li [hidden]="!canViewRoles">
              <a id="rolesTab" [routerLink]="[]" fragment="roles" href="#roles" data-toggle="tab"><i class="fa fa-shield fa-fw" aria-hidden="true"></i> {{'pageHeader.Roles' | translate}}</a>
            </li>
            <li [hidden]="!canManagePasswordPolicy">
              <a id="passwordPolicyTab" [routerLink]="[]" fragment="passwordPolicy" href="#passwordPolicy" data-toggle="tab"><i class="fa fa-key fa-fw" aria-hidden="true"></i> Password Policy</a>
            </li>
          </ul>
        </div>
        <div class="col-sm-12">
          <div class="tab-content">
            <div class="tab-pane active" id="profile">
              <!--<h4>{{'pageHeader.UserProfile' | translate}}</h4>
              <hr class="separator-hr" />-->
              <div [@fadeInOut] *ngIf="isProfileActivated" class="content-container">
                <!-- same profile as the top-right "User Profile" page, so the two can't drift apart -->
                <crm-user-profile [embedded]="true"></crm-user-profile>
              </div>
            </div>

            <div class="tab-pane" id="preferences">
              <h4>{{'pageHeader.UserPreferences' | translate}}</h4>
              <hr class="separator-hr" />
              <div [@fadeInOut] *ngIf="isPreferencesActivated" class="content-container">
                <user-preferences></user-preferences>
              </div>
            </div>

            <div class="tab-pane" id="users">
              <h4>{{'pageHeader.UsersManagements' | translate}}</h4>
              <hr class="separator-hr" />
              <div [@fadeInOut] *ngIf="canViewUsers && isUsersActivated" class="content-container">
                <users-management></users-management>
              </div>
            </div>

            <div class="tab-pane" id="roles">
              <h4>{{'pageHeader.RolesManagement' | translate}}</h4>
              <hr class="separator-hr" />
              <div [@fadeInOut] *ngIf="canViewRoles && isRolesActivated" class="content-container">
                <roles-management></roles-management>
              </div>
            </div>

            <div class="tab-pane" id="passwordPolicy">
              <h4>Password Policy</h4>
              <hr class="separator-hr" />
              <div [@fadeInOut] *ngIf="canManagePasswordPolicy && isPasswordPolicyActivated" class="content-container">
                <password-policy-management></password-policy-management>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</div>
